module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showSelect) ? _c('select-field', {
    attrs: {
      "siblingError": _vm.siblingError,
      "name": _vm.subFields[1].name,
      "useparent": true,
      "options": _vm.stateList
    },
    on: {
      "informError": function($event) {
        _vm.$emit('informError')
      },
      "clearError": function($event) {
        _vm.$emit('clearError')
      }
    }
  }) : _c('text-field', {
    attrs: {
      "siblingError": _vm.siblingError,
      "name": _vm.subFields[0].name,
      "useparent": true
    },
    on: {
      "informError": function($event) {
        _vm.$emit('informError')
      },
      "clearError": function($event) {
        _vm.$emit('clearError')
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-447c77ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/RegionField.vue
// module id = 117
// module chunks = 66 67 68 69